import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Item from './Item'

function Legend({ children }: React.PropsWithChildren<Record<string, unknown>>) {
  return (
    <Box flexDirection="row" gap="s16">
      {children}
    </Box>
  )
}

Legend.Item = Item

export default Legend
